const EQUAL_TO = 'equalTo';
const EQUAL_TO_OR_LESS_THAN = 'equalToOrLessThan';
const EQUAL_TO_OR_MORE_THAN = 'equalToOrMoreThan';
const LESS_THAN = 'lessThan';
const MORE_THAN = 'moreThan';

export default Object.freeze({
    [EQUAL_TO]: 0,
    [EQUAL_TO_OR_LESS_THAN]: 1,
    [EQUAL_TO_OR_MORE_THAN]: 2,
    [LESS_THAN]: 3,
    [MORE_THAN]: 4,
});

export const BreakRuleConditionNames = Object.freeze({
    0: EQUAL_TO,
    1: EQUAL_TO_OR_LESS_THAN,
    2: EQUAL_TO_OR_MORE_THAN,
    3: LESS_THAN,
    4: MORE_THAN,
});
